import { Trans, useTranslation } from 'next-i18next/pages';

import { ReactComponent as ArrowDiagonal } from '@pflegia/ui/icons/arrow-diagonal.svg';

import permanentImage from '@public/assets/employment-types/permanent.png';
import temporaryImage from '@public/assets/employment-types/temporary.png';

import EmploymentTypeCard from './EmploymentTypeCard';

const SelectEmploymentType: React.FC = () => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'selectEmploymentType' });

  return (
    <div className='flex flex-col items-center'>
      <div className='relative mb-8 flex flex-col items-center md:mb-20'>
        <h2 className='mb-4 text-2xl text-default md:mb-6 md:text-4xl'>
          <Trans components={{ span: <span className='font-handwriting text-3xl text-main-blue md:text-5xl' /> }} i18nKey='title' t={t} />
        </h2>
        <h3 className='text-secondary md:text-lg'>
          <Trans components={{ span: <span className='text-main-blue' /> }} i18nKey='subtitle' t={t} />
        </h3>
        <ArrowDiagonal className='absolute -left-2 bottom-4 hidden -translate-x-full translate-y-full -scale-x-100 text-main-blue md:block' />
        <ArrowDiagonal className='absolute -right-2 bottom-4 hidden translate-x-full translate-y-full text-main-blue md:block' />
      </div>
      <div className='grid grid-cols-[373px] gap-6 md:grid-cols-[repeat(2,373px)]'>
        <EmploymentTypeCard alt={t('permanent.altText')} image={permanentImage} name='permanent' />
        <EmploymentTypeCard alt={t('temporary.altText')} image={temporaryImage} name='temporary' />
      </div>
    </div>
  );
};

export default SelectEmploymentType;
